/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbRespAppliedFilters_user$ref = any;
type SbSharedRefineMenuDisplayPrefsSelect_user$ref = any;
type SbSharedRefineMenuFilters_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespRefineMenu_user$ref: FragmentReference;
export type SbRespRefineMenu_user = {|
  +$fragmentRefs: SbRespAppliedFilters_user$ref & SbSharedRefineMenuFilters_user$ref & SbSharedRefineMenuDisplayPrefsSelect_user$ref,
  +$refType: SbRespRefineMenu_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespRefineMenu_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespAppliedFilters_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDisplayPrefsSelect_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '74ebce40e67e74dec2659a58bcf480b0';
module.exports = node;
